// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const DeleteCustomFieldDefinitionDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-deletecustomfielddefinitiondialogcontainer" */ "./DeleteCustomFieldDefinitionDialogContainer")).then((bundle)=>{
        return {
            default: bundle.DeleteCustomFieldDefinitionDialogContainer
        };
    });
export const LazyDeleteCustomFieldDefinitionDialogContainer = /*#__PURE__*/ lazy(DeleteCustomFieldDefinitionDialogContainerLazyLoader);
